export * from './client.js';
export * from './auth.js';
export * from './models.js';
export * from './model_data.js';
export * from './media.js';
export * from './fansly_fyp.js';
export * from './photo_sessions.js';
export * from './events.js';
export * from './users.js';
export * from './engineApi.js';
export * from './graphConfigs.js';
export * from './graph_settings.js';
export * from './custom_contents.js';
export * from './onboarding.js';

import { apiJson } from './client.js';

function qs(params = {}) {
  const out = new URLSearchParams();
  for (const [key, value] of Object.entries(params || {})) {
    if (value === undefined || value === null || value === '') continue;
    out.set(key, String(value));
  }
  const text = out.toString();
  return text ? `?${text}` : '';
}

export async function getAiTestRuns(params = {}) {
  return apiJson(`/test/runs${qs(params)}`, {}, 'Failed to load AI test runs');
}
